import React from 'react';


import { CashbackInfo } from '../../../../../models';
import { AnnouncementSmallPopup } from './small';
import { AnnouncementPopup } from './default';

interface RewardsAnnouncementPopupProps {
  currency: string;
  smallView: boolean;
  onClose: () => void;
  cashbackInfo: CashbackInfo;
}

export const RewardsAnnouncementPopup: React.FC<RewardsAnnouncementPopupProps> = ({
  onClose,
  currency,
  smallView,
  cashbackInfo
}) => {
  return (
    smallView ? (
      <AnnouncementSmallPopup onClose={onClose} />
    ) : (
      <AnnouncementPopup
        onClose={onClose}
        currency={currency}
        cashbackInfo={cashbackInfo}
      />
    )
  );
};
